import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useParams,
  useLocation,
} from "react-router-dom";
import "@/App.css";
import ScrollToTop from "@/components/ScrollToTop";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { I18nProvider, isSupportedLang, readStoredLang, DEFAULT_LANG } from "@/lib/i18n";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

const LangLayout = ({ onOpenCookiePreferences }) => {
  const { lang } = useParams();
  const safeLang = isSupportedLang(lang) ? lang : DEFAULT_LANG;
  return (
    <I18nProvider lang={safeLang}>
      <a href="#main" className="skip-link">
        Databridgar
      </a>
      <Header />
      <main id="main">{isSupportedLang(lang) ? <Outlet /> : <NotFound />}</main>
      <Footer onOpenCookiePreferences={onOpenCookiePreferences} />
    </I18nProvider>
  );
};

const RootRedirect = () => {
  const stored = readStoredLang();
  return <Navigate to={`/${stored || DEFAULT_LANG}`} replace />;
};

/** Consent UI lives outside the language layout, so it derives the language itself. */
const ConsentLayer = ({ signal }) => {
  const location = useLocation();
  const first = (location.pathname || "").split("/").filter(Boolean)[0];
  const lang = isSupportedLang(first) ? first : DEFAULT_LANG;
  return (
    <I18nProvider lang={lang}>
      <CookieConsent openSignal={signal} />
    </I18nProvider>
  );
};

function App() {
  const [cookieSignal, setCookieSignal] = useState(0);
  const openCookiePreferences = () => setCookieSignal((n) => n + 1);

  return (
    <div className="App noise">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route
            path="/:lang"
            element={<LangLayout onOpenCookiePreferences={openCookiePreferences} />}
          >
            <Route index element={<Home />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="cookies" element={<CookiePolicy />} />
            <Route path="terms" element={<TermsAndConditions />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path="*"
            element={
              <I18nProvider lang={DEFAULT_LANG}>
                <Header />
                <main id="main">
                  <NotFound />
                </main>
                <Footer onOpenCookiePreferences={openCookiePreferences} />
              </I18nProvider>
            }
          />
        </Routes>
        <ConsentLayer signal={cookieSignal} />
      </BrowserRouter>
    </div>
  );
}

export default App;
